import { render, staticRenderFns } from "./FoodSearch.vue?vue&type=template&id=3a63f0cd"
import script from "./FoodSearch.vue?vue&type=script&lang=js"
export * from "./FoodSearch.vue?vue&type=script&lang=js"
import style0 from "./FoodSearch.vue?vue&type=style&index=0&id=3a63f0cd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports